// Module
var code = "<div> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> </div>";
// Exports
module.exports = code;